export default __webpack_public_path__ + "static/colour_config-8a55d64c5a2212d7515fd87c4965cc96.gif";